export default {
  getPendingAnswers: (state) => state.pendingAnswers,
  getPagination: (state) => state.pagination,
  getLinks: (state) => state.links,
  getFlowsFilter: (state) => state.flowsFilter,
  getSelectedProcess: (state) => state.selectedProcess,
  getSelectedProcessesList: (state) => state.selectedProcessesList,
  getSelectedProcessAnswers: (state) => state.selectedProcessAnswers,
};
